// The rail on a narrow screen: a row with room for a few entries and a
// "More" button holding the rest, so every screen stays reachable on a
// phone (the row used to overflow and cut the first and last entries off).
// Pure, so the arithmetic is tested without the DOM.

/** How many entries fit in a row `width` wide of `slot`-wide entries, one slot kept for "More" when not all fit. */
export function capacity(width: number, slot: number, total: number): number {
  if (!(slot > 0) || !(width > 0)) return total;
  const slots = Math.floor(width / slot);
  if (slots >= total) return total;
  return Math.max(0, slots - 1);
}

/**
 * Splits the entries into the ones shown in the row and the ones behind
 * "More": the first `n`, except that the active entry is always shown
 * (it takes the last shown place), so the row says where the user is.
 */
export function split<T extends { id: string }>(entries: readonly T[], n: number, activeId: string | undefined): { shown: T[]; hidden: T[] } {
  if (n >= entries.length) return { shown: [...entries], hidden: [] };
  const shown = entries.slice(0, n);
  const hidden = entries.slice(n);
  const at = hidden.findIndex((e) => e.id === activeId);
  if (at >= 0 && shown.length) {
    const swapped = shown[shown.length - 1];
    shown[shown.length - 1] = hidden[at];
    hidden[at] = swapped;
  }
  return { shown, hidden };
}
